import copy from 'copy-to-clipboard'
import useToast from '~hooks/useToast'
import { globalLang } from '~globalLang'

export const STRIP_TAGS_REGEX = /<[^>]*>/g
/**
 * useCopy hook
 */
function useCopy(showToast = true, stripTags?: boolean) {
    const handleCopyNotification = useToast({ caption: globalLang.copyNotification, dataPointer: 'toast_copy' })

    return (inputValue: string) => {
        const copyValue = stripTags ? inputValue.replace(STRIP_TAGS_REGEX, '') : inputValue
        copy(copyValue)
        showToast && handleCopyNotification()
    }
}

export default useCopy
